'use client';

import React, { FC } from 'react';

import PartOrderSection from '@/components/part-order-section';
import PartPageBanner from '@/components/UI/part-page-banner';
import { IDivider } from '@/contentful/utils/divider';
import { IService } from '@/contentful/utils/services';
import { useLanguage } from '@/context/LanguageContext';

import PartOtherServices from './part-other-services';
import PartServiceContent from './part-service-content';

interface IPartServicesView {
  data: {
    service: IService[];
    dividers: IDivider[];
    services: IService[];
  };
}

const PageServices: FC<IPartServicesView> = ({ data }) => {
  const { language } = useLanguage();

  const servicePage = data.service.filter((item) => item.lang === language)[0];

  const serviceDividers = data.dividers.filter((item) => item.lang === language)[0];

  const servicesList = data.services.filter((item) => item.lang === language);

  const servicePageBannerData = {
    title: servicePage.title,
    category: servicePage.category,
    imageDesktop: servicePage.imageBannerDesktop,
    imageMobile: servicePage.imageBannerMobile,
  };

  const parentPage = [{
    text: 'Services',
    href: language === 'lv' ? '/services' : `/${language}/services`,
  }];

  const servicePageContent = {
    header: servicePage.title,
    description: servicePage.description,
    icon: servicePage.icon,
    image: servicePage.image,
    imageMobile: servicePage.imageMobile,
    detailes: servicePage.detailes,
  };

  const servicePageDivider = {
    lang: language,
    title: serviceDividers.title,
    description: serviceDividers.description,
    buttonName: serviceDividers.buttonName,
    slug: serviceDividers.slug,
  };

  const otherServices = {
    lang: language,
    title: servicePage.otherServices,
    services: servicesList,
  };

  return (
    <main>
      <PartPageBanner data={servicePageBannerData} parentPage={parentPage} />
      <PartServiceContent data={servicePageContent} />
      <PartOrderSection data={servicePageDivider} />
      <PartOtherServices data={otherServices} />
    </main>
  );
};

export default PageServices;
